// Mensaje de error de guardado de los formularios discretos — ver useGuardado.ts.
import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, AlertDescription } from '@/components/ui/alert';

export function ErrorGuardado({ error }: { error: string | null }): JSX.Element | null {
  const { t } = useTranslation();
  if (!error) return null;
  return (
    <Alert variant="red">
      <AlertDescription>{t('formulario.errorGuardar', { error })}</AlertDescription>
    </Alert>
  );
}
